<template>
    <div class="tile-details w-100">
        <div class="pb-0 mb-0 no-wrap px-0 w-100 tile-details__title">
            <slot name="name"></slot>
        </div>
        <div class="pb-0 mt-0 no-wrap px-0 w-100 tile-details__description">
            <slot name="description"></slot>
        </div>
    </div>

</template>




<script>

export default {
    name: 'TileDetails',
}

</script>



<style scoped lang="scss">
.tile-details {

    &__title {
        overflow: hidden;
        color: #FFF;
        text-overflow: ellipsis;
        font-size: 13px;
        font-weight: 700;
    }
    
    &__description {
        overflow: hidden;
        color: rgba(255, 255, 255, 0.6);
        text-overflow: ellipsis;
        font-size: 10px;
        font-weight: 500;
        line-height: 14px;
    }
}
</style>